export default __webpack_public_path__ + "static/af-458ab7e0c32d14aefe334255c26dc561.svg";